import { createGlobalStyle } from 'styled-components'
import { CONFIG } from '../config'

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: Kollektif;
    src: url('${CONFIG.MARKETING_URL}assets/webfonts/Kollektif.woff')
        format('woff'),
      url('${CONFIG.MARKETING_URL}assets/webfonts/Kollektif.ttf')
        format('truetype');
  }

  @font-face {
    font-family: Kollektif;
    font-weight: bold;
    src: url('${CONFIG.MARKETING_URL}assets/webfonts/Kollektif-Bold.woff')
        format('woff'),
      url(${CONFIG.MARKETING_URL}assets/webfonts/Kollektif-Bold.ttf)
        format('truetype');
  }

  html {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
    font-weight: 300;
  }

  body {
    font-family: ${(p) => p.theme.fonts.fontFamily};
    font-size: ${(p) => p.theme.fonts.fontSize};
    line-height: 1.65;
    color: ${(p) => p.theme.colors.fonts.fontColor};
    background: #eee;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  img {
    display: block;
    width: 100%;
  }

  h1,
  h2,
  h3 {
    font-size: 2em;
    font-weight: normal;
    margin: 0;
    padding: 0;
  }

  p {
    margin: 0;
    padding: 0;
  }

  a {
    color: currentColor;
  }

  small {
    font-size: ${(p) => p.theme.fonts.fontSizeSmall};
    margin: 0;
    padding: 0;
  }
`
